export const apiQuery = 'obto.API("<collection>").query({oquery:"domain="+obto.root.domain,stream:!0,sort:"order",project:"name,_id,amount,category,schedule,order,type"}).$promise.then(function(allcharges){$scope.FeeHeads=_.uniq(allcharges,function(val){return val.name})})';

export const deleteCommand = 'ob.db.delete("<collection>", {\n' +
    '  domain: "domain"\n' +
    '}, {}, (err, doc) => {\n' +
    '  print("Done")\n' +
    '})\n';

export const findOneCommand = 'ob.db.findOne("<collection>", {\n' +
    '  domain: "domain"\n' +
    '}, {}, (err, doc) => {\n' +
    '  print("Done")\n' +
    '})\n';

export const bulkManipulate = 'const DB = ob.db.getConnection();\n' +
    'const domain = "domain";\n' +
    'const session = ob.getProperty("co.obto.edu.current.session", domain);\n' +
    '\n' +
    'DB.collection("collection").find({\n' +
    '  domain: domain,\n' +
    '  session: session,\n' +
    '  admission_no: {\n' +
    '    $exists: false\n' +
    '  }\n' +
    '}).toArray(function(error, results) {\n' +
    '  print(results.length);\n' +
    '  ob.async.eachSeries(results, function(item, cb) {\n' +
    '    let saveDoc = {};\n' +
    '    saveDoc.old_amount = item.amount;\n' +
    '    DB.collection("collection").updateOne({\n' +
    '      _id: new ob.objectId(item._id),\n' +
    '      domain: domain,\n' +
    '      session: session\n' +
    '    }, {\n' +
    '      $set: saveDoc\n' +
    '    }, {\n' +
    '      w: 1,\n' +
    '      upsert: false\n' +
    '    }, function(err, result) {\n' +
    '      cb();\n' +
    '    });\n' +
    '\n' +
    '  }, function(err) {\n' +
    '    print("Done");\n' +
    '  });\n' +
    '});';

export const updateCommand = 'const updateOptions = {\n' +
    '    propogate: false,\n' +
    '    sync: true,\n' +
    '    domain: _domain,\n' +
    '    user: {\n' +
    '        userid: "obto.admin",\n' +
    '        user_name: "admin"\n' +
    '    }\n' +
    '};' +
    'ob.db.update(\n' +
    '                    "class",\n' +
    '                    {\n' +
    '                        name: val,\n' +
    '                        session: _session,\n' +
    '                        domain: _domain\n' +
    '                    },\n' +
    '                    {\n' +
    '                        $set: {\n' +
    '                            strength: count\n' +
    '                        }\n' +
    '                    },\n' +
    '                    {\n' +
    '                        w: 1,\n' +
    '                        upsert: false\n' +
    '                    },\n' +
    '                    updateOptions,\n' +
    '                    () => {\n' +
    '                        cb();\n' +
    '                    }\n' +
    '                );';

export const queueQuery = 'const _domain = "yourdomain";\n' +
    'let process = (_doc, done) => {\n' +
    
    '};\n' +
    '\n' +
    'const q = ob.async.queue(function (task, callback) {\n' +
    '    process(task.document, callback);\n' +
    '}, 50);\n' +
    '\n' +
    'q.drain = function () {\n' +
    '    print("All Completed");\n' +
    '};\n' +
    '\n' +
    'let query = {\n' +
    '    },\n' +
    '    options = {\n' +
    '        limit: 1\n' +
    '    };\n' +
    '\n' +
    'let eod = document => {\n' +
    '    q.push(\n' +
    '        {\n' +
    '            document: document\n' +
    '        },\n' +
    '        function (err) {\n' +
    '            if (err) {\n' +
    '                ob.log(JSON.stringify(err));\n' +
    '            }\n' +
    '        }\n' +
    '    );\n' +
    '};\n' +
    '\n' +
    'let ocom = () => {\n' +
    '    print("All Queued");\n' +
    '};\n' +
    '\n' +
    'ob.db.findStream("collection", query, options, eod, ocom);';

export const react_dom = 'ReactDOM.render(\n' +
    '          obto.React.createElement(RCVerificationReport, {\n' +
    '            verificationCoordinates: response.verificationCoordinates,\n' +
    '            studentCoordinates: response.studentCoordinates,\n' +
    '            students: response.students,\n' +
    '            processedStudents: response.processedStudents,\n' +
    '            titles: response.titles,\n' +
    '            domain: obto.root.domain,\n' +
    '            reducedSubjects: response.reducedSubjects,\n' +
    '            categoriesToBeCombined: response.categoriesToBeCombined,\n' +
    '            reportType: reportType\n' +
    '          }),\n' +
    '          document.getElementById("container")\n' +
    '        );';
